module.exports = __webpack_public_path__ + "049ff75d73fee84e6c830e42fa4a5106.pdf";